export default "__VITE_ASSET__CvWEqibz__"